<div class="page-section">
      <h2 class="page-heading">Collaborators</h2>
    </div>
  
<div class="page-section">
    <nav class="about-nav">
        <ul>
            <li><a href="./collaborators#nav-content-1" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'atbc_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">AllTheBacteria project</a></li>
            <li><a href="./collaborators#nav-content-2" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'kinetoplastid_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Wheeler Lab</a></li>
            <li><a href="./collaborators#nav-content-3" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'bfvd_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Steinegger Lab</a></li>
            <li><a href="./collaborators#nav-content-8" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'mirdita_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Mirdita Lab</a></li>
            <li><a href="./collaborators#nav-content-5" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'viro3d_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">NVIDIA</a></li>
            <li><a href="./collaborators#nav-content-7" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'vadb_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Atkinson Lab</a></li>
            <li><a href="./collaborators#nav-content-9" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'cath_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">CATH and Jones groups</a></li>
            <li><a href="./collaborators#nav-content-4" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'viro3d_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Grove Lab</a></li>
            <li><a href="./collaborators#nav-content-10" (click)="gaService.eventEmitter(
      'collaborator_link',
      'collaborator_interaction',
      'click',
      'viralzone_link_visit',
      'When a user clicks on a collaborator dataset name on an entry page')">Philippe Le Mercier and the ViralZone team</a></li>
        </ul>
    </nav>
</div>

<section class="about-intro">
<div class="page-section">
    <p class="large-text">
        The AlphaFold Protein Structure Database works with research groups and scientific consortia that contribute specialist expertise, high-quality structure predictions, annotations and tools.
    </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-1">
<div class="page-section">
        <h3 class="nav-content-heading">AllTheBacteria project</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-28" target="_blank" class="bactTitle">AllTheBacteria protein structures</a></div>
        <p class="normal-text">
            <a href="https://allthebacteria.org/" target="_blank" class="bactTitle">AllTheBacteria</a> is a collaborative, open-access project that assembles and annotates bacterial and archaeal genomes from public sequencing data.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-2">
<div class="page-section">
        <h3 class="nav-content-heading">Wheeler Lab, University of Edinburgh</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-29" target="_blank" class="bactTitle">Kinetoplastid protein structures</a></div>
        <p class="normal-text">
            The <a href="https://wheelerlab.net/" target="_blank" class="bactTitle">Wheeler Lab</a> studies the cell biology of <em>Leishmania</em>, <em>Trypanosoma</em> and related parasites. The lab contributed protein structure predictions generated using enhanced multiple sequence alignments, improving predictions for proteins from these evolutionarily under-represented organisms.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-3">
<div class="page-section">
        <h3 class="nav-content-heading">Steinegger Lab, Seoul National University</h3>

        <div class="bacttitlebox">Dataset: <a href="/faq#faq-30" target="_blank" class="bactTitle">Big Fantastic Virus Database (BFVD)</a>; <a href="/faq#faq-36" target="_blank" class="bactTitle">Proteome-scale complex prediction</a>; <a href="/faq#faq-42" target="_blank" class="bactTitle">Viral complexes</a></div>
        <div class="bacttitlebox">Contributions: Foldseek, AFDB Clusters, AFDB50 collection</div>
        <p class="normal-text">
            The <a href="https://steineggerlab.com/en/" target="_blank" class="bactTitle">Steinegger Lab</a> develops scalable, open-source methods for analysing biological sequences and structures. Its contributions to the AFDB include Foldseek, which enables rapid structure-similarity searches across the database; AFDB Clusters, which groups predicted structures into structural clusters to reveal distant relationships; and the AFDB50 collection, which groups proteins at 50% sequence identity to support efficient exploration of structural space.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-8">
<div class="page-section">
        <h3 class="nav-content-heading">Mirdita Lab, Sungkyunkwan University School of Medicine</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-36" target="_blank" class="bactTitle">Proteome-scale complex prediction</a>; <a href="/faq#faq-42" target="_blank" class="bactTitle">Viral complexes</a></div>
        <p class="normal-text">
            <a href="https://mirdita.org/index.en.html" target="_blank" class="bactTitle">Milot Mirdita</a> leads the Laboratory for Computational Biology and Molecular Machine Learning. The group develops scalable, open bioinformatics infrastructure for sequence analysis, clustering and structure prediction. Mirdita co-developed ColabFold, which is used by several community datasets represented in AFDB, and collaborated on the proteome-scale homodimer and heterodimer predictions.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-5">
<div class="page-section">
        <h3 class="nav-content-heading">NVIDIA</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-36" target="_blank" class="bactTitle">Proteome-scale dimer structures</a>; <a href="/faq#faq-42" target="_blank" class="bactTitle">Viral complexes</a></div>
        <p class="normal-text">
            <a href="https://research.nvidia.com/labs/dbr/" target="_blank" class="bactTitle">NVIDIA</a> develops accelerated computing methods for scientific research. Its researchers collaborated with EMBL-EBI, Google DeepMind and academic partners to adapt and run structure-prediction workflows at the scale required for AFDB protein-complex predictions, including homodimers and heterodimers.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-7">
<div class="page-section">
        <h3 class="nav-content-heading">Atkinson Lab, Lund University</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-40" target="_blank" class="bactTitle">Viral AlphaFold Database (VAD)</a></div>
        <p class="normal-text">
            The <a href="https://atkinson-lab.com/" target="_blank" class="bactTitle">Atkinson Lab</a> uses computational and experimental approaches to study protein function and evolution, with a particular interest in microbial attack and defence systems.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-9">
<div class="page-section">
        <h3 class="nav-content-heading">CATH and Jones groups, University College London</h3>
        <div class="bacttitlebox">Contributions: The Encyclopedia of Domains (TED)</div>
        <p class="normal-text">
            The <a href="https://ted.cathdb.info/" target="_blank" class="bactTitle">CATH group</a> led by Christine Orengo and the group led by David Jones jointly developed TED. TED identifies structural domains in AlphaFold models and maps them to known CATH classifications where possible, providing the domain annotations displayed on AFDB entry pages.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-4">
<div class="page-section">
        <h3 class="nav-content-heading">Grove Lab, MRC–University of Glasgow Centre for Virus Research</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-32" target="_blank" class="bactTitle">Viro3D</a>; <a href="/faq#faq-42" target="_blank" class="bactTitle">Viral complexes</a></div>
        <p class="normal-text">
            The <a href="https://www.gla.ac.uk/schools/infectionimmunity/staff/joegrove/" target="_blank" class="bactTitle">Grove Lab</a> combines at-scale protein structure prediction and classical experimental virology to investigate molecular mechanisms in viruses. In particular, the group focuses on viral entry glycoproteins and their interactions with the host. Along with colleagues at the Centre for Virus Research, The Grove Lab contributed the Viro3D dataset to the AFDB, and collaborated on proteome-level complex prediction for priority viral families.
        </p>
    </div>
</section>

<section class="nav-content-section" id="nav-content-10">
<div class="page-section">
        <h3 class="nav-content-heading">Philippe Le Mercier and the ViralZone team, SIB Swiss Institute of Bioinformatics</h3>
        <div class="bacttitlebox">Dataset: <a href="/faq#faq-42" target="_blank" class="bactTitle">Viral complexes</a></div>
        <p class="normal-text">
            <a href="https://www.sib.swiss/swiss-prot" target="_blank" class="bactTitle">Philippe Le Mercier</a> leads the ViralZone team within SIB's Swiss-Prot group. ViralZone develops and curates comprehensive knowledge resources for virology, including virion structure and taxonomy, genome organisation, viral enzymes, and the mapping of polyprotein cleavage sites, all linked to viral protein records in UniProtKB.
        </p>
    </div>
</section>

